import type { TFunction } from 'i18next';
import { ORIGINALS } from './catalog.js';

const FALLBACK = new Map(ORIGINALS.map((o) => [o.code, o.name]));

/**
 * Localized display name for an Originals game code. The catalog name is the
 * English fallback; per-language overrides live under `originals:games.<code>.name`.
 * Works from any bound `t` (the namespace-prefixed key resolves the originals bundle).
 */
export function originalName(code: string, t: TFunction): string {
  return t(`originals:games.${code}.name`, { defaultValue: FALLBACK.get(code) ?? code });
}
